import { PageHeader } from "./PageHeader";
import "@styles/form.css";

export const Page = (props: any) => {
  const { breadcrumbs = true, title } = props;
  let body = <></>;
  if (props.children !== undefined) {
    body = props.children as any;
  }

  return (
    <div>
      <div className="ebd-card mb-3">
        <PageHeader {...{ breadcrumbs, title }}></PageHeader>
      </div>
      <div className="ebd-card page-content">{body}</div>
    </div>
  );
};

export const PageContainer = (props: any) => {
  let body = <></>;
  if (props.children !== undefined) {
    body = props.children as any;
  }

  return <div className="h-100">{body}</div>;
};
